import { sanitizeHtml } from './html'
import './content.css'

// 편집 결과와 기존 HTML을 같은 뷰어에서 표시한다. 모델 파싱을 거치지 않으므로
// 기존 글은 읽기 화면에서 재직렬화되지 않으며, 실행 가능한 내용만 정제한다.
function render (element, binding) {
  element.classList.add('happy-editor-content')
  if (binding.value !== binding.oldValue || !element.hasAttribute('data-editor-rendered')) {
    element.innerHTML = sanitizeHtml(binding.value)
    element.setAttribute('data-editor-rendered', '')
  }
}

export default { bind: render, update: render }



// WEBPACK FOOTER //
// ./src/components/ETC/editor/content.js